// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wheeldiv[data-v-c7cb568a]{display:grid;grid-template-columns:2fr 2fr 2fr 2fr 2fr;grid-template-rows:1fr 1fr}", ""]);
// Exports
module.exports = exports;
